module.exports = __webpack_public_path__ + "static/img/404.e7afdfe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/404.png
// module id = 137
// module chunks = 1 2